'use client'

import { PriceModelImage } from './price-model-image'
import type { PriceModelData } from './price-section-types'

import { NativeProductSelect } from '../native-product-select'

interface PriceModelSelectProps {
  models: Pick<PriceModelData, 'id' | 'name' | 'imageUrl'>[]
  selectedModelId: number
  ariaLabel: string
  onSelect: (modelId: number) => void
}

const ChevronIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 16 10" fill="none" className="h-2.5 w-4">
    <path d="m1.5 1.5 6.5 6.5 6.5-6.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
)

/** Image picker for releases with six or more models. */
export const PriceModelSelect = ({ models, selectedModelId, ariaLabel, onSelect }: PriceModelSelectProps) => {
  const selected = models.find((model) => model.id === selectedModelId) ?? models[0]

  return (
    <NativeProductSelect
      value={String(selected.id)}
      ariaLabel={ariaLabel}
      options={models.map((model) => (
        <option key={model.id} value={String(model.id)}>
          {model.name}
        </option>
      ))}
      onValueChange={(value) => {
        const modelId = Number(value)
        if (models.some((model) => model.id === modelId)) {
          onSelect(modelId)
        }
      }}
      className="border-navy-20 text-navy flex min-h-16 w-full cursor-pointer items-center gap-3 rounded-xl border bg-white px-3 py-2 text-left transition-colors hover:border-lapis focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lapis"
    >
      <PriceModelImage imageUrl={selected.imageUrl} />
      <span className="flex min-w-0 flex-1">
        <span className="truncate text-base font-semibold">{selected.name}</span>
      </span>
      <span className="text-navy-60 ml-auto shrink-0">
        <ChevronIcon />
      </span>
    </NativeProductSelect>
  )
}
